<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="addLeaveModal" tabindex="-1" role="dialog" aria-labelledby="addLeaveModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Apply Leave</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <label class="typo__label">Select Leave Type</label>
                <select v-model="leaveObj.leaveType" class="form-control">
                  <option value="">Select</option>
                  <option v-for="(row, index) of leaveTypes" :key="index" :value="row.key">{{ row.value }}</option>
                </select>
              </div>
            </div>
            <div v-if="leaveObj.leaveType !== 'partialLeave'" class="row mt-15">
              <div class="col-md-6 col-lg-6 col-sm-6">
                <label class="typo__label">Select Start Date</label>
                <input @input="checkDate($event, 'start')" v-if="!leaveObj.leaveType || (leaveObj.leaveType && leaveObj.leaveType !== 'partialLeave')" v-model="leaveObj.start" :min="minDate" class="form-control" type="date">
              </div>
              <div class="col-md-6 col-lg-6 col-sm-6">
                <label class="typo__label">Select End Date</label>
                <input @input="checkDate($event, 'end')" v-if="!leaveObj.leaveType || (leaveObj.leaveType && leaveObj.leaveType !== 'partialLeave')" :disabled="!leaveObj.start" :min="leaveObj.start ? leaveObj.start : minDate" v-model="leaveObj.end" class="form-control" type="date">
              </div>
            </div>
            <div v-else class="row mt-15">
              <div class="col-md-4 col-lg-4 col-sm-4">
                <label class="typo__label">Select Start Date</label>
                <input v-model="leaveObj.partialDate" :min="minDate" class="form-control" type="date">
              </div>
              <div class="col-md-4 col-lg-4 col-sm-4">
                <label class="typo__label">Start Time</label>
                <select :disabled="!leaveObj.partialDate" class="form-control" v-model="leaveObj.partialStartTime">
                  <option v-for="time in modifiedTimeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </div>
              <div class="col-md-4 col-lg-4 col-sm-4">
                <label class="typo__label">End Time</label>
                <select :disabled="!leaveObj.partialDate || !leaveObj.partialStartTime" class="form-control" v-model="leaveObj.partialEndTime">
                  <option v-for="time in modifiedTimeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </div>
            </div>
            <p class="text-danger mt-15 fw-600" v-for="(error, index) in errors" :key="index">{{error}}</p>
            <div v-show="leaveObj.leaveType !== 'sick'  " class="row mt-15 d-flex align-items-center justify-content-center">
              <div v-for="(row, index) of totalDays" @mouseover="getTitle(row, true, index) " @mouseleave="getTitle(row, false, index)" :id="`index_${index}`" :class="getBubbleClass(row)" :key="index" class="circle ml-5 make-cursor-pointer">{{ getDay(row) }}</div>
            </div>
            <div class="row mt-15">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <label class="typo__label">Details</label>
                <textarea v-model="leaveObj.details" class="form-control" rows="5"></textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <button @click="submit" :disabled="loading || errors.length > 0" type="button" class="btn btn-primary">
                  <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                  <span v-else>Submit</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {db} from "@/firebase/init";
import moment from "moment";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import axios from 'axios';
export default {
  name: "addLeaveModal",
  components: {
    Multiselect
  },
  computed: {
    getCurrentShift(){
      // const date = new Date(this.leaveObj.partialDate);
      // const currentDay = date.getDay();
      return this.allShifts[moment(this.leaveObj.partialDate).format('dddd')]
    },
    user(){
      return this.$store.getters.user;
    },
    modifiedTimeOptions() {
      const timeArray = this.generateTimeOptions;
      const currentDayShift = this.getCurrentShift
      console.log('currrent day sift', currentDayShift)
      return timeArray.filter(el => {
        if(currentDayShift) {
          if(currentDayShift.shiftIn < currentDayShift.shiftOut) {
            if(currentDayShift.shiftIn <= el && currentDayShift.shiftOut >= el) {
              return true
            }
          } else {
            if(el >= currentDayShift.shiftIn || el <= currentDayShift.shiftOut) {
              return true
            }
          }
        }
        return false
      })
    },
    generateTimeOptions() {
      const options = [];
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < 60; j += 30) {
          const hour = i.toString().padStart(2, '0');
          const minute = j.toString().padStart(2, '0');
          options.push(`${hour}:${minute}`);
        }
      }
      return options;
    },
  },
  data() {
    return {
      minDate: '',
      totalDaysData: {},
      errors: [],
      allShifts: {},
      currentDayShift: {},
      daysOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      adminShiftTime: {},
      loading: false,
      leaveObj: {},
      myLeaves: [],
      futureLeaves: [],
      totalDays: [],
      errorMessages: {
        partialStartTime: 'You have selected a start time that does not match your shift timings',
        partialEndTime: 'You have selected an end time that does not match your shift timings',
      },
      leaveTypes: [
        {key: 'sick', value: 'Sick'},
        {key: 'pto', value: 'PTO'},
        {key: 'vacation', value: 'Vacation'},
        {key: 'workEvent', value: 'Work Event'},
        {key: 'partialLeave', value: 'Partial Leave'},
      ]
    }
  },
  watch: {
    'leaveObj.leaveType' (val) {
      this.totalDays = [];
      if(this.leaveObj.start && this.leaveObj.end) {
        this.calculateTotalDays(this.leaveObj.start, this.leaveObj.end)
      }
      // this.leaveObj.start = ''
      // this.leaveObj.end = ''
    },
    'leaveObj.end' (val) {
      if(this.leaveObj.start) {
        this.calculateTotalDays(this.leaveObj.start,val)
      }
    },
    'leaveObj.partialStartTime' (val) {
      console.log(this.getCurrentShift)
      if(this.getCurrentShift) {
        if(!this.isTimeInShift(val, this.getCurrentShift.shiftIn, this.getCurrentShift.shiftOut)) {
          this.errors = this.errors.filter(el => el !== this.errorMessages.partialStartTime)
          this.errors.push(this.errorMessages.partialStartTime)
        } else {
          this.errors = this.errors.filter(el => el !== this.errorMessages.partialStartTime)
        }
      }
    },
    'leaveObj.partialEndTime' (val) {
      if(this.getCurrentShift) {
        // end time should be greater than partialStartTime if shift is same day, if shift is diff day then end time should be less than partialStartTime
        // const checkEndTime = this.currentDayShift.shiftIn < this.currentDayShift.shiftOut ? val < this.leaveObj.partialStartTime : val < this.leaveObj.partialStartTime;
        if(!this.isTimeInShift(val, this.getCurrentShift.shiftIn, this.getCurrentShift.shiftOut, 'end')) {
          this.errors = this.errors.filter(el => el !== this.errorMessages.partialEndTime)
          this.errors.push(this.errorMessages.partialEndTime)
        } else {
          this.errors = this.errors.filter(el => el !== this.errorMessages.partialEndTime)
        }
      }
    },
    'leaveObj.partialDate' (val) {
      this.calculateTotalDays(val, val)
    },
    'leaveObj.start' (val) {
      if(this.leaveObj.end) {
        this.calculateTotalDays(val,this.leaveObj.end)
      }
    }
  },
  methods: {
    // isOverlapping(newStart, newEnd) {
    //   const newStartDate = new Date(newStart);
    //   const newEndDate = new Date(newEnd);
    //
    //   return this.myLeaves.some(range => {
    //     const existingStart = new Date(range.start);
    //     const existingEnd = new Date(range.end);
    //
    //     // Check if ranges overlap
    //     return (
    //         newStartDate <= existingEnd && newEndDate >= existingStart
    //     );
    //   });
    // },
    checkDate(e, type) {
      console.log('aue', e.target.value)
      const obj = this.myLeaves.find(el => el.leaveDays ? el.leaveDays.includes(e.target.value) : false)
      if(obj) {
        this.showToast({message: 'You have already applied leave for given date.' , duration: 4000}, true, 'danger')
        if(type === 'start') {
          this.leaveObj.start = ''
        } else {
          this.leaveObj.end = ''
        }
      }
    },
    getTodayDate() {
      this.minDate = moment().tz('America/New_York').format('YYYY-MM-DD');
    },
    getName(array){
      console.log('arra at 231', array)
      return array ? array.map(el => {
        return `${el.firstName}`
      }).join(', ') : ''
    },
    getTitle(row, flag, index) {
      if(!flag) {
        return true
      }
      console.log('array data', this.totalDaysData[row]);
      let title = '';
      if(this.totalDaysData[row] && this.totalDaysData[row].length) {
        title = `Heads up: ${this.getName(this.totalDaysData[row])} ${this.totalDaysData[row].length > 1 ? 'are' : 'is'} already on leave this day. You can still proceed if needed.`
      }
      if(!title) title += '✅ You\'re good to go — no one else is on leave for this day.'
      tippy(`#index_${index}`, {
        content: title,
        allowHTML: true,
        theme: 'dark', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    isTimeInShift(time, shiftIn, shiftOut) {
      if (shiftIn < shiftOut) {
        // Normal shift (same day) e.g. 09:00 - 18:00
        return time >= shiftIn && time <= shiftOut;
      } else {
        // Overnight shift (crosses midnight) e.g. 19:30 - 03:30
        return time >= shiftIn || time <= shiftOut;
      }
    },
    async getAdminShift(){
      try {
        const ref = await db.collection('admin-shifts').where('email', '==', this.email).limit(1).get();
        if(ref.size){
          const data = ref.docs[0].data()
          this.allShifts = data.shifts
        }
      } catch (e) {
        console.log('error hapened while applying for leave', e.toString())
      }
    },
    getCurrentTime(){
      let now = new Date();
      const easternTime = now.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      let finalDate=moment(easternTime).format("YYYY-MM-DDTkk:mm")
      console.log('final date', finalDate)
      return finalDate;
    },
    calculateTotalDays(startDate, endDate) {
      if(!endDate) {
        return
      }
      let start = new Date(startDate);
      let end = new Date(endDate);
      let dateArray = [];

      while (start <= end) {
        dateArray.push(start.toISOString().split('T')[0]); // Format as YYYY-MM-DD
        start.setDate(start.getDate() + 1); // Move to next day
      }
      console.log(dateArray);
      dateArray= dateArray.filter(el => {
        const obj = this.allShifts[moment(el).format('dddd')];
        return obj && obj.type
      })
      this.totalDays = dateArray;
    },
    getBubbleClass(row) {
      let className = 'green'
      if(this.leaveObj.leaveType === 'partialLeave') {
        console.log('in partial leave')
        if(this.leaveObj.partialDate && this.leaveObj.partialStartTime) {
          const array = this.futureLeaves.filter(el => {
            if(el.partialLeave) {
              console.log(el.email,el.status === 'approved', moment(el.partialLeave.date).tz('America/Chicago').format('YYYY-MM-DD') , moment(this.leaveObj.partialDate).tz('America/Chicago').format('YYYY-MM-DD') , this.leaveObj.partialStartTime >= el.partialLeave.from , this.leaveObj.partialStartTime < el.partialLeave.to)
              const startCondition = this.leaveObj.partialStartTime >= el.partialLeave.from && this.leaveObj.partialStartTime <= el.partialLeave.to
              const endCondition = this.leaveObj.partialEndTime && this.leaveObj.partialEndTime >= el.partialLeave.from && this.leaveObj.partialStartTime <= el.partialLeave.to
              return el.partialLeave ? moment(el.partialLeave.date).tz('America/Chicago').format('YYYY-MM-DD') === moment(row).tz('America/Chicago').format('YYYY-MM-DD') && (startCondition || endCondition) : false
            }

          });
          console.log(array.length)
          if(array.length){
            this.totalDaysData[row] = array;
            className = array.length > 1 ? 'red' : (array.length === 1 ? 'yellow' : 'green')
          }
        }
      } else {
        const array = this.futureLeaves.filter(el => el.status === 'approved' && el.leaveDays && !!el.leaveDays.find(el2 => moment(el2).tz('America/Chicago').format('YYYY-MM-DD') === moment(row).tz('America/Chicago').format('YYYY-MM-DD')));
        if(array.length){
          this.totalDaysData[row] = array;
          className = array.length > 1 ? 'red' : (array.length === 1 ? 'yellow' : 'green')
        }
      }
      return className
    },
    getDay(date) {
      return moment(date).format('D');
    },
    selectLeaveType(e){
      console.log('error', e.target.value);
      this.leaveObj.leaveType = e.target.value
    },
    async load(allLeaves, type) {
      console.log('allLeaves', allLeaves);
      Object.assign(this.$data, this.$options.data());
      this.myLeaves = allLeaves
      this.email = this.user.email;
      this.type = type
      $('#addLeaveModal').modal('show');
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      await this.getFutureLeaves()
      await this.getAdminShift()
      this.getTodayDate()
    },
    async getFutureLeaves() {
      try {
        this.futureLeaves = []
        const todayDate = moment(new Date()).format('YYYY-MM-DD');
        const ref = await db.collection('leaveRecords').get()
        if(ref.size) {
          ref.forEach(el => {
            const { leaveDays, partialLeave } = el.data();
            if(leaveDays) {
              const obj = leaveDays.find(el => new Date(el) >= new Date(todayDate))
              if(obj) {
                this.futureLeaves.push(el.data())
              }
            } else if(partialLeave) {
              if(new Date(partialLeave.date) >= new Date(todayDate)){
                this.futureLeaves.push(el.data())
              }
            }
          })
        }
      } catch (e) {
        console.log('error while finding future leaves', e);
      }
    },
    getDuration(row) {
      let partialTime  = 0
      const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
      const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
      const diffInMs = toTime - fromTime;
      const totalMinutes = Math.abs(diffInMs / (1000 * 60));
      partialTime = partialTime + totalMinutes
      return Number(partialTime/60)
    },
    async submit(){
      try{
        this.loading=true;
        // if(!this.leaveObj.start) {
        //   return this.showToast({message: 'You must select start date for applying leave.' , duration: 2000}, true, 'danger')
        // }
        const leaveObj = {
          start: this.leaveObj.start,
          end: this.leaveObj.end,
          details: this.leaveObj.details || '',
          leaveType: this.leaveObj.leaveType,
          status: 'pending',
          email: this.user.email,
          uid: this.user.uid,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          createdAt: new Date().toISOString()
        }
        if(this.leaveObj.leaveType === 'sick') {
          leaveObj.status = 'approved';
        }
        if(this.leaveObj.leaveType !== 'partialLeave') {
          leaveObj.leaveDays = this.totalDays;
          // spliting it because it was taking one date prior than selected date
          let start = this.leaveObj.start.split('-')
          let end = this.leaveObj.end ? this.leaveObj.end.split('-') : start
          // new Date(y, m - 1, d) cz m starts with 0 index
          leaveObj.totalDays = Math.ceil(Math.abs(new Date(start[0], start[1] - 1, start[2]) - new Date(end[0], end[1] - 1, end[2]))/(1000 * 60 * 60 * 24))
        } else if(this.leaveObj.leaveType === 'partialLeave') {
          leaveObj.partialLeave = {
            date: this.leaveObj.partialDate,
            from: this.leaveObj.partialStartTime,
            to: this.leaveObj.partialEndTime,
          }
          leaveObj.start = this.leaveObj.partialDate
          leaveObj.end = this.leaveObj.partialDate
        }
        await db.collection('leaveRecords').add(leaveObj)
        const resp = await axios.post('https://n8n.bigscoots.dev/webhook/e103f60f-143c-4f7d-9147-a7168fd6449e', {
          staffName: `${leaveObj.firstName} ${leaveObj.lastName}`,
          date: leaveObj.leaveType !== 'partialLeave' ? `${moment(leaveObj.start).format('DD MMM YYYY')} - ${moment(leaveObj.end).format('DD MMM YYYY')}` : `${moment(leaveObj.partialLeave.date).format('DD MMM YYYY')} ${leaveObj.partialLeave.from} - ${leaveObj.partialLeave.to}`,
          duration: leaveObj.leaveType !== 'partialLeave' ? leaveObj.leaveDays.length : this.getDuration(leaveObj),
          leaveType: leaveObj.leaveType
        }, {
          headers: {
            Authorization: 'Bearer oasdfjuasejf38fasd7fi23f7asdf7sdf'
          }
        })
        console.log('resp', resp.data)
        this.showToast({message: 'You have successfully submitted leave request.' , duration: 2000}, true, 'success')
        // await this.$parent.getAllLeaves();
        $('#addLeaveModal').modal('hide');
      }
      catch(e){
        console.log(e.toString())
        $('#addLeaveModal').modal('hide');
        this.showToast({message: `Something went wrong while submitting leave. ${e.toString()}` , duration: 2000}, true, 'danger')
      }finally {
        this.loading=false
      }
    }
  }
}
</script>

<style scoped>

.circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  //box-shadow: inset 5px 5px 15px rgba(255, 255, 255, 0.5),
  //inset -5px -5px 15px rgba(0, 0, 0, 0.3),
  //10px 10px 20px rgba(0, 0, 0, 0.2);
  //backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  color: white;
  //text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

/* Red Glass Marble */
.red {
  background: red;
  //background: linear-gradient(135deg, red, rgba(150, 0, 0, 0.4)),
  //radial-gradient(circle, rgba(255, 150, 150, 0.7) 10%, rgba(0, 0, 0, 0.3) 80%);
}

/* Yellow Glass Marble */
.yellow {
  color: black;
  background: yellow;
  //background: linear-gradient(135deg, yellow, rgba(200, 150, 0, 0.5)),
  //radial-gradient(circle, rgba(255, 255, 100, 0.7) 10%, rgba(0, 0, 0, 0.3) 80%);
}

/* Green Glass Marble */
.green {
  background: green;
  //background: linear-gradient(135deg, green, rgba(0, 150, 0, 0.4)),
  //radial-gradient(circle, rgba(150, 255, 150, 0.7) 10%, rgba(0, 0, 0, 0.3) 80%);
}
</style>
